import {
    scaleToBestUnit,
    getUnitDefinition,
} from '../../../../common/ui/formatting/scalingUnitServiceModule';

const MAX_CUSTOM_UNIT_LENGTH = 7;

function trimWithEllipsis(str, maxLen) {
    if (!str || str.length <= maxLen) return str || '';
    return str.substring(0, maxLen - 1) + '…';
}

export function trimCustomUnit(prefix, suffix) {
    const p = prefix || '';
    const s = suffix || '';
    if (p.length + s.length <= MAX_CUSTOM_UNIT_LENGTH) {
        return { prefix: p, suffix: s };
    }
    const half = Math.floor(MAX_CUSTOM_UNIT_LENGTH / 2);
    if (p.length > half && s.length > half) {
        const tp = trimWithEllipsis(p, half);
        return { prefix: tp, suffix: trimWithEllipsis(s, MAX_CUSTOM_UNIT_LENGTH - tp.length) };
    }
    if (p.length > half) {
        return { prefix: trimWithEllipsis(p, MAX_CUSTOM_UNIT_LENGTH - s.length), suffix: s };
    }
    return { prefix: p, suffix: trimWithEllipsis(s, MAX_CUSTOM_UNIT_LENGTH - p.length) };
}

export function getUnitLabel(unitType) {
    if (!unitType) return '';
    const unitDef = getUnitDefinition(unitType);
    return (unitDef && unitDef.abbreviation) || '';
}

export function formatWithUnit(value, unitType, customUnit, fallback, showRawValue = false) {
    if (value === '-') return fallback !== undefined ? fallback : '-';
    if (unitType && typeof value === 'number' && isFinite(value) && getUnitDefinition(unitType)) {
        const scaled = scaleToBestUnit(value, unitType);
        const rounded = parseFloat(scaled.value.toPrecision(6));
        const formatted = `${rounded}${scaled.unit.abbreviation}`;
        if (showRawValue && rounded !== value) {
            return `${formatted} (${value})`;
        }
        return formatted;
    }
    if (customUnit) {
        const p = customUnit.prefix || '';
        const s = customUnit.suffix ? ` ${customUnit.suffix}` : '';
        return `${p}${value}${s}`;
    }
    return `${value}${getUnitLabel(unitType)}`;
}
